import React, { useState, useEffect, Fragment } from 'react';
import { Row, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
// import './css/property.scss';
// import MessageResponse from './ResponseBlock/MessageResponse';
// import LinkResponse from './ResponseBlock/LinkResponse';
// import ImageCarouselResponse from './ResponseBlock/ImageCarouselResponse';

import { RotateSpinner } from 'react-spinners-kit';

import DialogInformation from './DialogInformation';
import ApiMessageResponse from './ApiMessageResponse';
import ApiHeroCardFixedResponse from './ApiHeroCardFixedResponse';
import SuggestResponse from './SuggestResponse';
import Message from '../Message/Message';
import Tag from '../Tag/Tag';
import MessageResponse from './MessageResponse';
import HeroResponse from './HeroResponse';
import TriggerResponse from './TriggerResponse';
import TagResponse from './TagResponse';
import GoToResponse from './GoToResponse';
import QuestionOptionsResponse from './QuestionOptionsResponse';
import {
  AddMessageToDialogButton,
  AddTagsToDialogButton,
  DeleteButton,
} from '../Button/AddButton';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { postAPI_BotDialogFile } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

function DialogResponse({
  elem,
  dialogIndex,
  dialogUpdate,
  dialogDelete,
  dialogNames,
}) {
  const [isAddMsg, setIsAddMsg] = useState(false);
  const [isAddTag, setIsAddTag] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = (dialogIndex) => {
    dialogDelete(dialogIndex);
    toggle();
  };
  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xxs="12" xs="3"></Colxx>
            <Colxx xs="9" sm="2" className="mb-1">
              <div
                onClick={() => {
                  setIsAddMsg(true);
                }}
              >
                <AddMessageToDialogButton className="add-button" />
              </div>
            </Colxx>
            <Colxx xs="12" sm="2" className="mb-1">
              <div onClick={toggle}>
                <DeleteButton className="add-button" />
              </div>
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This dialog will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete(dialogIndex)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const generator = () => {
    console.log('elm', elem);

    return (
      <Fragment>
        <Row>
          <Colxx xxs="12" xs="3">
            <DialogInformation elem={elem} />{' '}
          </Colxx>
          <Colxx xxs="12" xs="9">
            {elem.messages.map((msg, msgIndex) => {
              if (msg.type) {
                switch (msg.type) {
                  case 'apimessage':
                    return (
                      <Fragment key={msgIndex}>
                        <ApiMessageResponse
                          elem={elem}
                          dialogIndex={dialogIndex}
                          codeIndex={msgIndex}
                          apiCode={msg.apiCode}
                          dialogUpdate={dialogUpdate}
                        />
                      </Fragment>
                    );
                  case 'suggest':
                    return (
                      <Fragment key={msgIndex}>
                        <SuggestResponse
                          elem={elem}
                          dialogIndex={dialogIndex}
                          codeIndex={msgIndex}
                          dialogUpdate={dialogUpdate}
                          text={msg.text}
                          buttons={msg.buttons}
                        />
                      </Fragment>
                    );
                  case 'apimessage-herocard-fixed':
                    return (
                      <Fragment key={msgIndex}>
                        <ApiHeroCardFixedResponse
                          elem={elem}
                          dialogIndex={dialogIndex}
                          codeIndex={msgIndex}
                          dialogUpdate={dialogUpdate}
                          apiCode={msg.apiCode}
                          actions={msg.actions}
                        />
                      </Fragment>
                    );
                  case 'goto':
                    return (
                      <Fragment key={msgIndex}>
                        <GoToResponse
                          elem={elem}
                          dialogIndex={dialogIndex}
                          codeIndex={msgIndex}
                          message={msg}
                          dialogUpdate={dialogUpdate}
                          dialogNames={dialogNames}
                        />
                      </Fragment>
                    );
                  case 'herocard':
                    return (
                      <Fragment key={msgIndex}>
                        <HeroResponse
                          elem={elem}
                          dialogIndex={dialogIndex}
                          codeIndex={msgIndex}
                          message={msg}
                          dialogUpdate={dialogUpdate}
                          dialogNames={dialogNames}
                        />
                      </Fragment>
                    );
                  case 'questionoptions':
                    return (
                      <Fragment key={msgIndex}>
                        <QuestionOptionsResponse
                          elem={elem}
                          dialogIndex={dialogIndex}
                          codeIndex={msgIndex}
                          message={msg}
                          dialogUpdate={dialogUpdate}
                          dialogNames={dialogNames}
                        />
                      </Fragment>
                    );
                }
              } else {
                return (
                  <MessageResponse
                    elem={elem}
                    dialogIndex={dialogIndex}
                    codeIndex={msgIndex}
                    message={msg}
                    dialogUpdate={dialogUpdate}
                  />
                );
              }
            })}

            <TriggerResponse
              elem={elem}
              trigger={elem.triggers}
              dialogIndex={dialogIndex}
              dialogUpdate={dialogUpdate}
            />
            <TagResponse
              elem={elem}
              tags={elem.tag}
              dialogIndex={dialogIndex}
              dialogUpdate={dialogUpdate}
            />
          </Colxx>
        </Row>
        {isAddMsg ? (
          <Row>
            <Colxx xxs="12" xs="3"></Colxx>
            <Colxx md="9" className="mb-2">
              <Message
                setIsAddMsgToFalse={() => setIsAddMsg(false)}
                elem={elem}
                dialogUpdate={dialogUpdate}
                dialogIndex={dialogIndex}
                dialogNames={dialogNames}
              />
            </Colxx>
          </Row>
        ) : null}
        {isAddTag ? (
          <Row>
            <Colxx xxs="12" xs="3">
              <DialogInformation elem={elem} />{' '}
            </Colxx>
            <Colxx md="9" className="mb-2">
              <Tag
                setIsAddTagToFalse={() => setIsAddTag(false)}
                elem={elem}
                dialogUpdate={dialogUpdate}
                dialogIndex={dialogIndex}
              />
            </Colxx>
          </Row>
        ) : null}
        {generateButtonGroup()}
      </Fragment>
    );
  };

  return <Fragment>{generator()}</Fragment>;
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(DialogResponse));
